import { useTranslation } from 'react-i18next'

import { CountryFlag, FormatPrice, Text } from '@reveni-io/reveni-ui'

import CountriesInfoSkeleton from './CountriesInfoSkeleton/CountriesInfoSkeleton'
import * as Styles from './styles'

const CountriesInfo = ({ countries, regions, currency, loading, onClickInCountry }) => {
  const { t } = useTranslation()

  const getCountryNameByCode = code => {
    return regions.find(region => region.code === code)?.name || code
  }

  if (loading) return <CountriesInfoSkeleton />

  return (
    <Styles.TableContainer>
      <Styles.Table>
        <Styles.TableHead>
          <tr>
            <Styles.TableHeader colSpan={2}>
              <Text type="allCapsS">{t('País')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Número de pedidos')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Valor total de pedidos')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Valor medio de pedido')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Total de aduanas y envíos')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Valor medio de aduanas y envíos')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Precio total de envíos')}</Text>
            </Styles.TableHeader>
            <Styles.TableHeader>
              <Text type="allCapsS">{t('Coste total de aduanas')}</Text>
            </Styles.TableHeader>
          </tr>
        </Styles.TableHead>
        <tbody>
          {countries?.map((country, index) => (
            <Styles.TableRow key={country.code} onClick={() => onClickInCountry(country.country_code)}>
              <td>{index + 1}</td>
              <td>
                <Styles.CountryContainer>
                  <CountryFlag code={country.country_code} />
                  <Text type="bodyMRegular">{getCountryNameByCode(country.country_code)}</Text>
                </Styles.CountryContainer>
              </td>
              <td>
                <Text type="bodyMRegular">{country.total_orders_count}</Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.total_order_value}</FormatPrice>
                </Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.average_order_value}</FormatPrice>
                </Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.total_shipping_and_customs_collected}</FormatPrice>
                </Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.average_shipping_and_customs_collected}</FormatPrice>
                </Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.total_shipping_paid}</FormatPrice>
                </Text>
              </td>
              <td>
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{country.total_customs_paid}</FormatPrice>
                </Text>
              </td>
            </Styles.TableRow>
          ))}
        </tbody>
      </Styles.Table>
    </Styles.TableContainer>
  )
}

export default CountriesInfo
